<template>
  <v-container>
    <!-- <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs> -->
    <template v-if="item">
    <h2 class="text-h4">Visitor {{item.id}}</h2>
    <v-list width="100%">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Activity</v-list-item-subtitle>
            <v-list-item-title>{{ item.activity }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Last action</v-list-item-subtitle>
            <v-list-item-title>{{ item.lastAction }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    <h2>Last events</h2>
    <v-data-table show-expand :headers="headers" :items="item.events.items">
      <template v-slot:item.productname="i">
      <a v-if="i.item.product" :href="i.item.product.url">{{ i.item.product.name }}</a><span v-else>!!! Nonexistent product</span>
      </template>
      <template v-slot:expanded-item="i">
      <v-container>
      <v-list  width="100%">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Event ID</v-list-item-subtitle>
            <v-list-item-title>{{ i.item.id }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Product ID</v-list-item-subtitle>
            <v-list-item-title>{{ i.item.productID }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-container>
    </template>
    </v-data-table>
    <h2>Recommendations</h2>
    <v-data-table show-expand :headers="headers" :items="item.parsedRecommendations">
      <template v-slot:item.productname="i">
      <a :href="i.item.url">{{ i.item.name }}</a>
      </template>
      <template v-slot:expanded-item="i">
      <v-container>
      <v-list  width="100%">
        <!--
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Recommendation ID</v-list-item-subtitle>
            <v-list-item-title>{{ i.item.id }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Product ID</v-list-item-subtitle>
            <v-list-item-title>{{ i.item.id }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-container>
    </template>
    </v-data-table>
    </template>
    </v-container>
</template>

<script>

  import { mapState } from "vuex";
  import ParseRoute from "@/mixins/parse-route";

  export default {
    name: 'Visitor',
    mixins: [ParseRoute],
    data() {
      return {
        headers: [
          { text: 'Product', value: 'productname' },
          { text: 'Score', value: 'scoreIncrement' },
          { text: 'More', value: 'data-table-expand' },
        ]
      };
    },
    computed: {
      ...mapState('visitors', ['item'])
    },
    methods: {
      loadVisitor() {
          this.$store.dispatch('visitors/get', { id: this.visitor });
      }
    },
    created() {
      this.loadVisitor();
    }
  }
</script>
